export default {
  superDesktop: 'Reportes',
  addProductsToPurchase: 'Añadir productos a la compra',
  appNotifications: 'Notificaciones de la App',
  home: 'Inicio',
  peopleDirectory: 'Contactos',
  peopleList: 'Listas',
  listDetails: 'Detalles de la lista',
  roles: 'Tags',
  conversations: 'Conversaciones',
  conversationMetrics: 'Métricas de conversaciones',
  conversationSettings: 'Configura tu chat',
  businesses: 'Compañías',
  businessDetails: 'Detalles del negocio',
  campaigns: 'Campañas',
  newSms: 'Nuevo SMS',
  newCampaign: 'Nueva campaña',
  campaignDetails: 'Detalles de la campaña',
  triggers: 'Disparadores',
  notifications: 'Notificaciones',
  speechToText: 'Proyectos de Speech to text',
  authenticator: 'Autenticador',
  forms: 'Formularios',
  companyNotFound: 'No se encontraron compañías',
  upToDateNotifications: 'Estás al día con tus notificaciones',
  /* events */
  events: 'Eventos',
  eventDetail: 'Detalles del evento',
  assistants: 'Asistentes',
  promotors: 'Promotores',
  products: 'Productos',
  places: 'Lugares',
  productsSales: 'Compras de Productos',
  /* ORDERS */
  clients: 'Clientes',
  colors: 'Colores',
  containerTypes: 'Tipos de Contenedores',
  purchases: 'Compras',
  purchaseDetail: 'Detalle de Compra',
  sellers: 'Vendedores',
  suppliers: 'Proveedores',
  /* END ORDERS */
  settings: 'Configuración',
  details: 'Detalles',
  administrators: 'Usuarios',
  billing: 'Facturación',
  payments: 'Pagos',
  creditCards: 'Tarjetas de crédito',
  newApp: 'Nueva aplicación',
  newCompany: 'Nueva compañia',
  newPage: 'Nueva Página',
  servicesPerPage: 'Servicios por página',
  balance: 'Saldo',
  loadingTariffs: 'Cargando Tarifas',
  noTariffsOnTheListYet: 'Aún no hay tarifas en la lista',
  shortenLink: 'Acortar enlace',
  addCreditCard: 'Agregar tarjeta de crédito',
  addCard: 'AgregarTarjeta',
  load: 'Cargar',
  changePassword: 'Cambiar Contraseña',
  exit: 'Salir',
  value: 'Valor',
  support: 'Soporte',
  /* TOOLBAR CARD */
  services: 'Servicios',
  createAplication: 'Crear aplicación'
}
